import { Token } from '../lex/tokens';
import { WithMeta } from '../lex/types';

export const infixBindingPower = ([token, _meta]: WithMeta<Token>):
  | [number, number]
  | null => {
  switch (token.t) {
    case 'template':
      switch (token.kind) {
        case 'start':
        case 'continue':
        case 'end':
        case 'complete':
        default:
          return null;
      }
    case 'operator':
      return infixOperatorBindingPower(token.op);
    default:
      return null;
  }
};

export const infixOperatorBindingPower = (
  op: string
): [number, number] | null => {
  switch (op) {
    case ';':
      return [-5, -4];
    case '|>':
      return [2, 3];
    case '??':
      return [3, 4];
    case '&&':
    case '||':
      return [4, 5];
    case '>':
    case '<':
    case '<=':
    case '>=':
    case '==':
    case '!=':
      return [6, 7];
    case '+':
    case '-':
      return [8, 9];
    case '*':
    case '/':
    case '^':
      return [10, 11];
    case ':':
      return [11, 12];
    default:
      return null;
  }
};

export const postfixBindingPower = ([token, _meta]: WithMeta<Token>):
  | [number, null]
  | null => {
  switch (token.t) {
    case 'template': {
      switch (token.kind) {
        case 'end':
        case 'continue':
        case 'complete':
        case 'start':
        default:
          return null;
      }
    }
    case 'grouping': {
      switch (token.op) {
        case '|':
          return [-1, null];
        case '}':
          return [-1, null];
        case ')':
          return [-2, null];
        case ',':
          return [-3, null];
        default:
          return null;
      }
    }
    case 'operator': {
      switch (token.op) {
        case ':':
          return [-1, null];
        case '!':
          return [6, null];
        default:
          return null;
      }
    }
    case 'tag': {
      return [2, null];
    }
    default:
      return null;
  }
};
